import { BaseModel } from '../base-model';
export interface IAppointmentTypeParameterModel {

}

export class AppointmentTypeParameterModel extends BaseModel<IAppointmentTypeParameterModel> implements IAppointmentTypeParameterModel {

  /**
   *
   */
  constructor(options?: { [key: string]: any }) {
    super(options);
  }
}

